import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--color-charcoal)] border-t border-[var(--color-dark-purple)]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="font-serif text-3xl tracking-tight hover:text-[var(--color-gold)] transition-colors">
              {siteConfig.name}
            </Link>
            <p className="mt-4 text-[var(--color-cream)]/50 max-w-md leading-relaxed">
              A reflective sanctuary for seekers—where inquiry, ritual, and emotional depth shape conscious living.
            </p>
            <a 
              href={`mailto:${siteConfig.email}`}
              className="mt-6 inline-block text-[var(--color-gold)] hover:text-[var(--color-gold-light)] transition-colors"
            >
              {siteConfig.email}
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[var(--color-gold)]">
              Explore
            </h4>
            <nav className="flex flex-col gap-3">
              <Link
                to="/about"
                className="text-[var(--color-cream)]/50 hover:text-[var(--color-gold)] transition-colors text-sm"
              >
                Philosophy
              </Link>
              <Link
                to="/coaching"
                className="text-[var(--color-cream)]/50 hover:text-[var(--color-gold)] transition-colors text-sm"
              >
                Coaching
              </Link>
              <Link
                to="/tarot"
                className="text-[var(--color-cream)]/50 hover:text-[var(--color-gold)] transition-colors text-sm"
              >
                Tarot Readings
              </Link>
              <Link
                to="/collective"
                className="text-[var(--color-cream)]/50 hover:text-[var(--color-gold)] transition-colors text-sm"
              >
                The Collective
              </Link>
              <Link
                to="/toolkit"
                className="text-[var(--color-cream)]/50 hover:text-[var(--color-gold)] transition-colors text-sm"
              >
                Toolkit
              </Link>
            </nav>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[var(--color-gold)]">
              Connect
            </h4>
            <nav className="flex flex-col gap-3">
              <Link
                to="/contact"
                className="text-[var(--color-cream)]/50 hover:text-[var(--color-gold)] transition-colors text-sm"
              >
                Contact
              </Link>
              <a
                href={siteConfig.calendlyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[var(--color-cream)]/50 hover:text-[var(--color-gold)] transition-colors text-sm"
              >
                Book a Session
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[var(--color-dark-purple)]/15">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-[var(--color-cream)]/30">
              © {currentYear} {siteConfig.name}. All rights reserved.
            </p>
            <p className="text-xs text-[var(--color-cream)]/30 italic">
              This is a space for reflection, not prediction.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
